import React, { useState } from 'react';
import cssClasses from './SelectCrmUserModal.module.css';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../../Subcomponents/Button';
import DropDown from '../../../Subcomponents/DropDown';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CustomAutoComplete from '../../../Subcomponents/CustomAutoComplete';
import ConfirmationAlert from '../../../Subcomponents/ConfirmationAlert';
import { errorTost, successTost } from '../../../Services/Toast';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { insertCRMLogs } from '../../../Services/AllAllotments';
import { updateToCRMTable } from '../../../Services/Users';
import { useSelector } from 'react-redux';
import { crm2Reassign } from '../../../Services/Crm2List';
import { unitLine } from '../../Crm2/ui/cardParts';

// crm2 (M2-F8, prototype reassignModal): { card, options } for a CRM 2.0 booking — the project's CRMs with their open
// bookings, a reason, "Email the customer" and the save on the server (POST /crm2/reassign). Without it: today's pop-up.
function SelectCrmUserModal({open, handleClose, crmUsersList: oldList, heading, allotment, crm2 = null}) {

  const crmUsersList = crm2
    ? (crm2.options?.crms || []).map((u) => ({ ...u, label: `${u.name} · ${u.openBookings} open bookings`, value: `${u.name} · ${u.openBookings} open bookings`, crmUserDocUrl: u.hasDocuments ? ["uploaded"] : [] }))
    : oldList;
  console.log({crmUsersList});

  const [reason, setReason] = useState("");
  const [reasonHelperText, setReasonHelperText] = useState("");
  const [emailCustomer, setEmailCustomer] = useState(crm2?.options?.settings?.emailCustomer !== false);
  const reasonRequired = crm2?.options?.settings?.reasonRequired !== false;
  const [selectedCrmUser, setSelectedCrmUser] = useState(null);
  const [selectedCrmUserHelperText, setSelectedCrmUserHelperText] = useState("");
  const [openAlertBox, setOpenAlertBox] = useState(false);
  const loggedInUser = useSelector((state) => state.Auth.user);

  function submitHandler() {
    if (crm2 && reasonRequired && !reason.trim()) {
      setReasonHelperText("Please enter the reason");
      return;
    }
    if(heading === "Reassign CRM"){
      setOpenAlertBox(true);
    }else{
      handleClose({flag: true, selectedCrmUser})  
    }
  }

  async function handleReassignCRM() {
    presentLoader();
    if (crm2) {
      const picked = crmUsersList.find((el) => el.value === selectedCrmUser?.value);
      try {
        await crm2Reassign(crm2.card.allotmentPaymentId, { crmUserId: picked?.userId, reason: reason.trim(), emailCustomer });
        successTost("CRM Reassigned Successfully");
        setOpenAlertBox(false);
        handleClose({ done: true });
      } catch (err) {
        console.error("[crm2][SelectCrmUserModal] reassign failed", { allotmentPaymentId: crm2.card.allotmentPaymentId, message: err?.response?.data?.message || err?.message });
        errorTost(err?.response?.data?.message || "Error while CRM Reassigned");
        setOpenAlertBox(false);
      } finally {
        dismissLoader();
      }
      return;
    }
    let crmUser = selectedCrmUser?.value;
    let crmUserId  = crmUsersList[crmUsersList.findIndex((el) => el.label === crmUser)].userId;

    updateToCRMTable(crmUserId, allotment?.allotment_payment_id).then(async (res) => {
      console.log("Res", res);
      const crmUserName = crmUsersList[crmUsersList.findIndex((el) => el.label === crmUser)].name;
      const crmObj = {
        message : `CRM user of allotment unit ${allotment?.unit_no} of Project ${allotment?.project_name} is changed from ${allotment?.crm_user_name} to ${crmUserName} by ${loggedInUser?.name}`,
        allotmentPaymentId: res?.[0]?.allotmentPaymentId,
        crmStatus: "CRM reassigned"
      }
      insertCRMLogs(crmObj).then((res) => {
        console.log("Logs saved", res);
        successTost("CRM Reassigned Successfully")
        setOpenAlertBox(false);
        handleClose();
      }).catch((err) => {
        console.log(err);
        errorTost("Error while CRM Reassigned")
        dismissLoader();
        setOpenAlertBox(false);
        handleClose();
        dismissLoader();
      })
    }).catch((err) => {
      console.log(err);
      errorTost("Error while CRM Reassigned")
      setOpenAlertBox(false);
      handleClose();      
      dismissLoader();
    })
  }


  return (
    <>
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root":{
            background: "rgba(193, 201, 210, 0.7)"
          }
        }
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>{heading}</h1>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
          <IconButton className={cssClasses.crossButton} onClick={handleClose}> <CloseIcon /> </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
            {crm2 && (
              <Box mb={"2rem"}>
                <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#101828" }}>{unitLine(crm2.card)} · {crm2.card.leadName}</Typography>
                <Typography sx={{ fontSize: "13px", color: "#667085", mt: "0.4rem" }}>
                  Current CRM: <b style={{ color: "#101828" }}>{crm2.options?.current?.name}</b> · {crm2.card.ring?.day ? `Day ${crm2.card.ring.day} of ${crm2.card.ring.total}` : "clock not started"}
                </Typography>
              </Box>
            )}
            <Box className={cssClasses.inputContainer}>
              <Typography sx={[labelStyle]}>CRM User{crm2 && <sup style={{ color: "red" }}> *</sup>}</Typography>
              <CustomAutoComplete
                NoOptionsText={'No user found'}
                InitialValue={(_value) => {
                  if (_value) {
                    setSelectedCrmUser(_value);
                    setSelectedCrmUserHelperText("")
                  } else {
                    setSelectedCrmUser("")
                    setSelectedCrmUserHelperText("Please select CRM user.");
                  }
                }}
                list={crmUsersList}
                multiple={false} disable={false}
                value={selectedCrmUser}
                helperText={selectedCrmUserHelperText}
                />
              
              { selectedCrmUser !== null && (crmUsersList.find(f => f?.value === selectedCrmUser?.value)?.crmUserDocUrl?.length === 0) && 
                <Box mt={"2rem"} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                  <WarningAmberRoundedIcon color={"warning"} style={{width: "4rem", height: "4rem"}}/>
                  <Typography style={{...labelStyle, marginLeft: "1rem", marginBottom: "unset"}}>Documents were not found for this CRM user.</Typography>
                </Box>
              }
              {crm2 && (
                <>
                  <Typography sx={{ fontSize: "12px", color: "#667085", mt: "0.6rem" }}>Only CRMs tagged to {crm2.card.projectName} (Users › Assign Project).</Typography>
                  <Typography sx={[labelStyle, { mt: "2rem" }]}>Reason{reasonRequired && <sup style={{ color: "red" }}> *</sup>}</Typography>
                  <textarea
                    aria-label="Reason"
                    value={reason}
                    maxLength={500}
                    placeholder="Why is this booking moving?"
                    onChange={(e) => { setReason(e.target.value); if (e.target.value.trim()) setReasonHelperText(""); }}
                    style={{ width: "100%", minHeight: "8rem", fontSize: "14px", padding: "1rem 1.2rem", border: "1px solid #D0D5DD", borderRadius: "0.8rem", fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }}
                  />
                  {reasonHelperText && <Typography sx={{ fontSize: "12px", color: "#D92D20", mt: "0.4rem" }}>{reasonHelperText}</Typography>}
                  {crm2.options?.settings?.emailCustomer !== false && (
                    <label style={{ display: "flex", alignItems: "center", gap: "0.8rem", marginTop: "1.6rem", fontSize: "14px", color: "#344054", cursor: "pointer" }}>
                      <input type="checkbox" checked={emailCustomer} onChange={(e) => setEmailCustomer(e.target.checked)} /> Email the customer the new CRM's name and phone number
                    </label>
                  )}
                  <Box sx={{ mt: "2rem", p: "1.2rem 1.4rem", background: "#EFF8FF", border: "1px solid #B2DDFF", borderRadius: "0.8rem", color: "#175CD3", fontSize: "13px", lineHeight: "1.9rem" }}>
                    The 15 days do not restart. The new CRM gets a bell and an email and sees the booking in every tab; the old CRM gets a bell. The move is saved in the timeline.
                  </Box>
                </>
              )}
            </Box>
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div><Button style={{ color: "#344054", backgroundColor: "#ffffff" }} btnName={"Cancel"} clicked={handleClose} /></div>
          <div><Button style={{ color: "#ffffff", backgroundColor: "#155EEF" }} btnName={"Submit"} disable={!Boolean(crmUsersList?.find(f => f?.value === selectedCrmUser?.value)?.crmUserDocUrl?.length > 0)} clicked={submitHandler}/></div>
        </div>
      </Box>
    </Modal>
    {openAlertBox && (
      <ConfirmationAlert
        confirm={(e) => {
          if(e === "confirmed"){
            handleReassignCRM();
          }else{
            setOpenAlertBox(false);
          }
        }}
        buttonTitle={"Cancel"}
        returnRespButton={"Continue"}
        close={() => setOpenAlertBox(false)}
        title={"Warning"}
        subTitle={`Are you sure! Do you want to link crm user - ${crm2 ? crmUsersList.find((el) => el.value === selectedCrmUser?.value)?.name || "" : selectedCrmUser?.value}`}
        open={openAlertBox}
      />
      )}
    </>
  )
}

export default SelectCrmUserModal;
const labelStyle = {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#344054",
  marginBottom: "0.8rem"
}